import { Col, Row } from 'antd'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Model from './Model'
import { FacebookOutlined, InstagramOutlined, MailOutlined, TwitterOutlined, WhatsAppOutlined } from '@ant-design/icons'
const Footers = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
    <div className='footer'>
      <h4>We Welcome Your Passion and Expertise</h4>
      <p style={{padding : 10}}>Join our empowering Travel community today and explore with us.</p>
      <div className="boxButton" onClick={showModal}>
        Join With Us
      </div>
      <Model isModalOpen={isModalOpen} handleOk={handleOk} handleCancel={handleCancel} />
      <div className="container">
        <Row gutter={[30, 30]} style={{width : "100%"}}>
          <Col xs={24} sm={12} md={8} lg={8} xl={6} style={{display : "flex" , justifyContent : "center"}} >
          <div className="footer-rows">
            <h6>Contact us</h6>
            <div>
              <p>Mobile<br />
                <span>+91 9600881327 </span><br />
                <span>+91 9600881328</span></p>
            </div>
            <div>
            <p>Need Live Suppot <br /><span>tours@travelanceholidays.com</span></p>
            </div>
            </div>
          </Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={6} style={{display : "flex" , justifyContent : "center"}} >
          <div className="footer-rows">
            <h6>Quick Links</h6>
            <div className="footer-row-column">
              <Link to={'/aboutUs'}>About us</Link>
              {/* <Link to={'/'}>Blog</Link> */}
              <Link to={'/packages/international'}>Int Package</Link>
              <Link to={'/packages/domestic'}>Dom Package</Link>
              <Link to={'/contactUS'}>Contact us</Link>
            </div>
            </div>
          </Col>
          {/* <Col xs={24} sm={12} md={8} lg={8} xl={4}  className="footer-rows">
            <h6>Support</h6>
            <div className="footer-row-column">
              <Link to={'/'}>Contact</Link>
              <Link to={'/'}>Legal Notice</Link>
              <Link to={'/'}>Privacy Policy</Link>
              <Link to={'/'}>Terms & Conditions</Link>
              <Link to={'/'}>Payment Policy</Link>
            </div>
          </Col> */}
          {/* <Col xs={24} sm={12} md={8} lg={8} xl={4}  className="footer-rows">
            <h6>Other Links</h6>
            <div className="footer-row-column">
              <Link to={'/'}>Coaches</Link>
              <Link to={'/'}>Sports Venue</Link>
              <Link to={'/'}>Join As Coach</Link>
              <Link to={'/'}>Add Venue</Link>
              <Link to={'/'}>My Account</Link>
            </div>
          </Col> */}
          <Col xs={24} sm={12} md={8} lg={8} xl={6}  style={{display : "flex" , justifyContent : "center"}} >
          <div className="footer-rows">
            <h6>Our Locations</h6>
            <div className="footer-row-column">
              <Link to={'/'}>Chennai</Link>
              {/* <Link to={'/'}>Russia</Link>
              <Link to={'/'}>France</Link>
              <Link to={'/'}>UK</Link>
              <Link to={'/'}>Colombia</Link> */}
            </div>
            </div>
          </Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={6}  style={{display : "flex" , justifyContent : "center"}} >
          <div className="footer-rows">
            <h6>Social Links</h6>
            {/* <div style={{ display: "grid", gap: 13 }}>
              <div className="boxButton1">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                  <path d="M15.2755 5.19C15.6535 4.75428 15.9418 4.24817 16.1237 3.70074C16.3056 3.1533 16.3775 2.57533 16.3355 2C15.1748 2.09369 14.0975 2.63956 13.3355 3.52C12.9706 3.94198 12.694 4.43288 12.5223 4.96364C12.3505 5.49441 12.287 6.05424 12.3355 6.61C12.9016 6.61472 13.4612 6.4891 13.9711 6.24286C14.4809 5.99662 14.9272 5.63637 15.2755 5.19ZM17.7955 12.63C17.8022 11.8637 18.004 11.1118 18.3819 10.4452C18.7598 9.77859 19.3014 9.21926 19.9555 8.82C19.5427 8.22524 18.997 7.73483 18.3617 7.38767C17.7264 7.04052 17.0189 6.84615 16.2955 6.82C14.7355 6.66 13.2955 7.73 12.4655 7.73C11.6355 7.73 10.4655 6.84 9.16545 6.86C8.31558 6.888 7.48747 7.13578 6.7619 7.57919C6.03633 8.02259 5.43806 8.64648 5.02545 9.39C3.26545 12.45 4.57545 17 6.33545 19.47C7.13545 20.68 8.13545 22.05 9.45545 22C10.7755 21.95 11.2055 21.18 12.7355 21.18C14.2655 21.18 14.7355 22 16.0355 21.97C17.3355 21.94 18.2555 20.73 19.0955 19.52C19.6905 18.6415 20.1553 17.6816 20.4755 16.67C19.6829 16.332 19.0068 15.7693 18.5305 15.0513C18.0542 14.3333 17.7987 13.4916 17.7955 12.63Z" fill="white" />
                </svg>
                <div>
                  <p>Download on the</p>
                  <span>App Store</span>
                </div>
              </div>
              <div className="boxButton1">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                  <path d="M21.2543 10.6531C20.9399 10.4832 18.2436 8.91875 17.2319 8.32989L17.2289 8.32789L4.97405 1.25275C4.76527 1.1253 4.53117 1.04501 4.28811 1.01749C4.04506 0.989977 3.79893 1.0159 3.56694 1.09345C3.54076 1.10285 3.51616 1.11231 3.49071 1.12396C3.43162 1.14322 3.37386 1.16634 3.3178 1.19318C3.08349 1.33323 2.89126 1.53385 2.76134 1.77393C2.63141 2.01401 2.56861 2.28468 2.57952 2.55744V21.5428C2.57209 21.7969 2.63227 22.0484 2.75392 22.2717C2.87557 22.4949 3.05433 22.6818 3.2719 22.8133C3.32209 22.8378 3.37379 22.8591 3.42669 22.877C3.45562 22.8904 3.4832 22.902 3.51305 22.9125C3.65626 22.9645 3.80709 22.9923 3.9594 22.9949C4.2519 22.9918 4.53845 22.912 4.79046 22.7635C5.17913 22.5379 17.2289 15.5809 17.2289 15.5809L21.2495 13.2596C21.498 13.1351 21.7078 12.945 21.8562 12.7099C22.0046 12.4747 22.0858 12.2035 22.0913 11.9256C22.079 11.6578 21.9948 11.3983 21.8475 11.1744C21.7003 10.9505 21.4953 10.7704 21.2543 10.6531ZM4.57952 19.8391V4.10199L12.5196 11.9611L4.57952 19.8391ZM9.59752 17.6774L13.941 13.3679L15.0906 14.5057C13.8259 15.236 11.6893 16.4697 9.59752 17.6775V17.6774ZM13.9393 10.5524L9.54145 6.19946L15.0951 9.40576L13.9393 10.5524ZM16.8861 13.4691L15.3607 11.9594L16.8885 10.4435C17.6087 10.8618 18.7313 11.5129 19.5044 11.9578L16.8861 13.4691Z" fill="white" />
                </svg>
                <div>
                  <p>Get it on</p>
                  <span>Google Play</span>
                </div>
              </div>
            </div> */}
<div className="footer-row-column">
<a target="_blank"  href='https://www.instagram.com/travelanceholidays/'  ><InstagramOutlined /> &nbsp;&nbsp; Instagram</a>
              {/* <Link to={'/'}>Blog</Link> */}
              <a target="_blank"  href='https://wa.me/+919600881327' ><WhatsAppOutlined />&nbsp;&nbsp; Whatsapp </a>
              <a target="_blank"  href='https://www.facebook.com/people/Travelance-Holidays/61567836713804/' ><FacebookOutlined />&nbsp;&nbsp; FaceBook</a>
              <a target="_blank"  href='https://x.com/TravelanceHDays' ><TwitterOutlined /> &nbsp;&nbsp; X</a>
            </div>
            </div>
          </Col>

        </Row>
      </div>
    </div>
     {/* =====================================  FooterEnd  =====================================  */}
<div className="footer-end">
<p>© 2024 Travelance  - All rights reserved.</p>
<div style={{display : "flex" , alignItems : "center" , gap : 31}}>
{/* <div style={{display : "flex" , alignItems : "center" , gap : 6}} >
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
        <g clipPath="url(#clip0_2261_250)">
        <path fillRule="evenodd" clipRule="evenodd" d="M8.96972 1.99984C5.65601 1.99984 2.96972 4.68613 2.96972 7.99984C2.96972 11.3135 5.65601 13.9998 8.96972 13.9998C12.2834 13.9998 14.9697 11.3135 14.9697 7.99984C14.9697 4.68613 12.2834 1.99984 8.96972 1.99984ZM1.63638 7.99984C1.63638 3.94975 4.91963 0.666504 8.96972 0.666504C13.0198 0.666504 16.303 3.94975 16.303 7.99984C16.303 12.0499 13.0198 15.3332 8.96972 15.3332C4.91963 15.3332 1.63638 12.0499 1.63638 7.99984Z" fill="#f8f8f89c"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M1.63638 8.00016C1.63638 7.63197 1.93486 7.3335 2.30305 7.3335H15.6364C16.0046 7.3335 16.303 7.63197 16.303 8.00016C16.303 8.36835 16.0046 8.66683 15.6364 8.66683H2.30305C1.93486 8.66683 1.63638 8.36835 1.63638 8.00016Z" fill="#f8f8f89c"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M6.96987 8.00007C7.01556 10.05 7.72055 12.0235 8.96971 13.6329C10.2189 12.0235 10.9239 10.05 10.9696 8.00007C10.9239 5.95018 10.2189 3.97663 8.96972 2.36727C7.72055 3.97663 7.01556 5.95018 6.96987 8.00007ZM8.96972 1.3334L8.47749 0.883789C6.70098 2.82868 5.69139 5.35264 5.63653 7.98619C5.63633 7.99544 5.63633 8.0047 5.63653 8.01396C5.69139 10.6475 6.70098 13.1715 8.47749 15.1164C8.60379 15.2546 8.78244 15.3334 8.96972 15.3334C9.157 15.3334 9.33564 15.2546 9.46195 15.1164C11.2385 13.1715 12.248 10.6475 12.3029 8.01396C12.3031 8.0047 12.3031 7.99544 12.3029 7.98619C12.248 5.35264 11.2385 2.82868 9.46195 0.883789L8.96972 1.3334Z" fill="#f8f8f89c"/>
        </g>
        <defs>
        <clipPath id="clip0_2261_250">
        <rect width="16" height="16" fill="white" transform="translate(0.969727)"/>
        </clipPath>
        </defs>
        </svg>
        <p>English (US)</p>
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
            <path d="M5.968 5.49822C5.8012 5.49845 5.63957 5.44027 5.51119 5.33376L1.22972 1.76174C1.08399 1.64048 0.992409 1.4663 0.975112 1.27751C0.957814 1.08872 1.01622 0.900793 1.13748 0.755068C1.25874 0.609343 1.43293 0.517758 1.62172 0.50046C1.81051 0.483162 1.99843 0.541569 2.14416 0.662831L5.96893 3.86335L9.79728 0.781408C9.87034 0.722147 9.95439 0.677909 10.0446 0.651237C10.1348 0.624566 10.2294 0.615985 10.3229 0.62599C10.4165 0.635995 10.5071 0.664386 10.5896 0.709534C10.6722 0.754682 10.745 0.815695 10.8038 0.889067C10.8692 0.96251 10.9186 1.04866 10.9491 1.14211C10.9796 1.23556 10.9905 1.3343 10.9811 1.43214C10.9716 1.52999 10.9421 1.62483 10.8943 1.71073C10.8465 1.79663 10.7815 1.87173 10.7033 1.93133L6.41784 5.37711C6.28565 5.46664 6.12727 5.50929 5.968 5.49822Z" fill="#f8f8f89c"/>
            </svg>
        </div>
        <div style={{display : "flex" , alignItems : "center" , gap : 6}}>
           <p>$ USD</p>  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
            <path d="M5.968 5.49822C5.8012 5.49845 5.63957 5.44027 5.51119 5.33376L1.22972 1.76174C1.08399 1.64048 0.992409 1.4663 0.975112 1.27751C0.957814 1.08872 1.01622 0.900793 1.13748 0.755068C1.25874 0.609343 1.43293 0.517758 1.62172 0.50046C1.81051 0.483162 1.99843 0.541569 2.14416 0.662831L5.96893 3.86335L9.79728 0.781408C9.87034 0.722147 9.95439 0.677909 10.0446 0.651237C10.1348 0.624566 10.2294 0.615985 10.3229 0.62599C10.4165 0.635995 10.5071 0.664386 10.5896 0.709534C10.6722 0.754682 10.745 0.815695 10.8038 0.889067C10.8692 0.96251 10.9186 1.04866 10.9491 1.14211C10.9796 1.23556 10.9905 1.3343 10.9811 1.43214C10.9716 1.52999 10.9421 1.62483 10.8943 1.71073C10.8465 1.79663 10.7815 1.87173 10.7033 1.93133L6.41784 5.37711C6.28565 5.46664 6.12727 5.50929 5.968 5.49822Z" fill="#f8f8f89c"/>
            </svg>
        </div> */}
</div>
</div>
    </>
  )
}

export default Footers